import { Injectable } from '@angular/core';
import LogRocket from 'logrocket';
import { whichEnv } from '../helpers/whichEnv';

// https://docs.logrocket.com/reference/track

@Injectable()
export class LogRocketTrackerService {
  track(identifier = 'LogRocketTrackerService', data = {}) {
    if (!whichEnv.isDevLike) {
      const trackedData = {
        ...data,
        timestamp: new Date().toTimeString()
      };
      LogRocket.track(identifier, trackedData);
    }
  }
}
